export class ProspectSource {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default ProspectSource;